// src/pages/LoginPage.js
import React, { useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { useNavigate } from "react-router-dom";
import { InteractionStatus } from "@azure/msal-browser";
import { useTranslation } from "react-i18next";

function LoginPage() {
  const { t } = useTranslation();
  const { instance, accounts, inProgress } = useMsal();
  const navigate = useNavigate();

  useEffect(() => {
    // Handle redirect promise on login page to clear the URL and complete login
    if (inProgress === InteractionStatus.None) {
      instance.handleRedirectPromise()
        .then((response) => {
          if (response) {
            // Login was successful, redirect to the desired path
            const redirectPath = sessionStorage.getItem('redirectPath') || "/";
            sessionStorage.removeItem('redirectPath'); // Clear the stored path
            navigate(redirectPath);
          } else if (accounts.length > 0) {
            // If already authenticated, redirect to home or original path
            const redirectPath = sessionStorage.getItem('redirectPath') || "/";
            sessionStorage.removeItem('redirectPath'); // Clear the stored path
            navigate(redirectPath);
          }
        })
        .catch((error) => {
          console.error("Login failed: ", error);
        });
    }
  }, [instance, accounts, inProgress, navigate]);

  return (
    <div className={`w-[100%] bg-mute-100`} style={{ height: window.innerHeight }}>
      <p>{t("login.processing")}</p>
    </div>
  );
}

export default LoginPage;
